module.exports = __webpack_public_path__ + "static/media/city-elements-facilities-4-svgrepo-com.d9bb799c.svg";